export default {"src":"/_next/static/media/logo-incena.cac154cb.svg","height":16,"width":46,"blurWidth":0,"blurHeight":0};